import React, { useEffect } from "react"
import { createContext, useContext, useState } from "react"
import { THEME } from "./themeConfig"

const ThemeContext = createContext()

const isBrowser = typeof window !== "undefined"

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(
    isBrowser
      ? window.localStorage.getItem("theme")
        ? window.localStorage.getItem("theme")
        : "dark"
      : "dark"
  )

  const toggleTheme = () => {
    setCurrentTheme(prevTheme => (prevTheme === "light" ? "dark" : "light"))
  }

  useEffect(() => {
    if (isBrowser) window.localStorage.setItem("theme", currentTheme)
  }, [currentTheme])

  return (
    <ThemeContext.Provider
      value={{
        themeType: currentTheme,
        theme: THEME[currentTheme],
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)
